import React, { useContext, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { logout } from "../../api/accounts";
import { updateUserData } from "../../api/users";
import AuthContext from "../../context/AuthContext";
import Swal from "sweetalert2";

export default function NavbarLoggedIn() {
  // Getting the auth context
  const { user }: any = useContext(AuthContext);

  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 1500,
    timerProgressBar: true,
    onOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });

  const handleLogout = () => {
    // if (!user.details.cards.firstLogin) {
    //   user.details.cards.firstLogin = true;
    // }
    // user.details.stats.timesLoggedIn++;
    // updateUserData(user.details, user.uid, user.userType);
    logout();
    Toast.fire({
      icon: "success",
      title: "Logged Out successfully",
    });
    // Redirect using html for page refresh
    setTimeout(() => {
      window.location.replace("/");
    }, 1000);
  };
  const [classNameNav, setClassNav] = useState("nav-link");
  const [classNameA, setClassA] = useState("nav-link dropdown-toggle");
  const handleScroll = () => {
    if (window.scrollY > 0) {
      setClassNav("nav-link scrolled");
      setClassA("nav-link dropdown-toggle scrolled");
    } else {
       setClassNav("nav-link");
       setClassA("nav-link dropdown-toggle");
    }
  }
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <ul className="navbar-nav mt-2 mt-lg-0">
      <li className="nav-item">
        <Link
          className={classNameNav}
          to="/home"
        >
          <i className="fas fa-home"></i> Home
        </Link>
      </li>
      {user.userType === "donor" ?
      <li className="nav-item">
        <Link
          className={classNameNav}
          to="/request-status"
        >
          <i className="fas fa-search"></i> Request Status
        </Link>
      </li>
      :
      null
    }
      {user.userType === "donor" ? (
        <li className="nav-item">
          <Link 
            className={classNameNav}
            to="/requests"
          >
          <i className="fas fa-heartbeat"></i> Requests
          </Link>
        </li>
      )
      : (
        <li className="nav-item">
          <Link
            className={classNameNav}
            to="/dashboard"
          >
            <i className="fas fa-columns"></i> Dashboard
          </Link>
        </li>
      )}
      <li className="nav-item">
        <Link
          className={classNameNav}
          to="/aboutus"
        >
          <i className="fas fa-users"></i> About Us
        </Link>
      </li>
      <li className="nav-item dropdown">
        <a
          className={classNameA}
          href="/"
          id="navbarDropdownMenuLink"
          role="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <i className="fas fa-user"></i> Welcome, {user.displayName}
        </a>
        <div
          className="dropdown-menu dropdown-menu-right"
          aria-labelledby="navbarDropdownMenuLink"
        >
          <Link className="dropdown-item" to="/profile">
            <i className="fas fa-address-card"></i> Profile
          </Link>
          <Link className="dropdown-item" to="/password">
            <i className="fas fa-key"></i> Edit Password
          </Link>
          <Link className="dropdown-item" to="/" onClick={handleLogout}>
            <i className="fas fa-hand-point-left"></i> Logout
          </Link>
        </div>
      </li>
    </ul>
  );
}
